import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
// import { ClassroomSummary } from '../classroom-summary/models/classroom-summary.model';
import { LoginService } from '../../shared-modules/login/login.service';
import { YearService } from '../../shared-components/year/year.service';
import { UserService } from '../../shared-components/user/user.service';
import { Year } from '../../shared-components/year/year.model';
import {
    MassEmail,
    ContactTypes,
    MassEmailStudent,
    MassEmailPreferences,
    Recipient
} from './mass-email.model';
import { User } from '../../shared-components/user/user.model';
import { UserPreferencesService } from '../../shared-components/user-preferences/user-preferences.service';
import { LoginSettings } from '../../shared-modules/login/LoginSetting.model';
import { MassEmailService } from './mass-email.service';
import { SelectRecipientsComponent } from './select-recipients/select-recipients.component';
import { ErrorList } from '../../shared-components/controls/error-prompt/error-list.model';
import { MassEmailAttachmentComponent } from './mass-email-attachment/mass-email-attachment.component';
import { Attachment } from '../../shared-components/models/attachment.model';
import { UserPreferencesWindowComponent } from '../../shared-components/user-preferences/user-preferences-window/user-preferences-window.component';
import { Portal } from '../../shared-components/portal.model';
import { SendEmailsWarningComponent } from './send-emails-warning/send-emails-warning.component';
import { JobSentToQueueComponent } from '../job-sent-to-queue/job-sent-to-queue.component';
import { ClassroomSummary } from '../../classroom360/classroom-summary/models/classroom-summary.model';
import * as _ from 'lodash';
import { ViewRecipientsModalComponent } from './view-recipients-modal/view-recipients-modal.component';
import { EmailRecipient } from './view-recipients-modal/email-recipient';
import { GeneralConfirmationComponent } from '../../shared-components/controls/general-confirmation/general-confirmation.component';
import { SendTestEmailComponent } from './send-test-email/send-test-email.component';
import { StudentTeams } from '../../classroom360/student-teams/student-teams.model';
import { StudentList } from '../../classroom360/student-lists/student-list.model';
import {Classroom360Service} from '../../classroom360/classroom360.service';
@Component({
    selector: 'app-mass-email-view',
    templateUrl: './mass-email-view.component.html',
    styleUrls: ['./mass-email-view.component.css']
})
export class MassEmailViewComponent implements OnInit {
    popUpWidth: number;
    popUpHeight: number;
    referringPage: string;
    massEmail: MassEmail;
    defaultYear: Year;
    currentUser: User;
    selectedStudents: MassEmailStudent[];
    selectedClasses: ClassroomSummary[];
    userPreferences: any;
    massEmailPreferences: MassEmailPreferences = new MassEmailPreferences();
    loginSettings: LoginSettings;
    public staffAssignedPortals: Portal[] = [];
    selectRecipiantDialogRef: MatDialogRef<SelectRecipientsComponent>;
    massEmailAttachmentDialogRef: MatDialogRef<MassEmailAttachmentComponent>;
    sendEmailsWarningDialogRef: MatDialogRef<SendEmailsWarningComponent>;
    jobSentToQueueDialogRef: MatDialogRef<JobSentToQueueComponent>;
    userPrefDialogRef: MatDialogRef<UserPreferencesWindowComponent>;
    generalConfirmationDialog: MatDialogRef<GeneralConfirmationComponent>;
    sendTestEmailDislogRef: MatDialogRef<SendTestEmailComponent>;
    errorList: ErrorList[] = [];
    errors: ErrorList[] = [];
    userEmailAddress = '';
    selectedStudentTeam: StudentTeams[] = [];
    selectedStudentList: StudentList[] = [];

    @ViewChild('attachmentFieldRef', { read: ElementRef }) attachmentFieldRef: ElementRef;
    @ViewChild('subjectFieldRef', { read: ElementRef, static: true }) subjectFieldRef: ElementRef;

    constructor(
        private loginService: LoginService,
        private yearService: YearService,
        private userService: UserService,
        private massEmailService: MassEmailService,
        private userPreferencesService: UserPreferencesService,
        private dialogRef: MatDialogRef<MassEmailViewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private classroom360Service: Classroom360Service,
        private dialogBox: MatDialogRef<MassEmailViewComponent>
    ) { }

    ngOnInit() {
        this.defaultYear = this.yearService.defaultYear;
        this.currentUser = this.userService.currentUser;
        this.userPreferences = this.userPreferencesService;
        this.loginSettings = this.loginService.LoginSettings;
        if (this.data) {
            if (this.data.massEmail) {
                this.massEmail = this.data.massEmail;
            }
            if (this.data.portals) {
                this.staffAssignedPortals = this.data.portals;
            } else {
                this.staffAssignedPortals = this.classroom360Service.staffAssignedPortals;
            }
        }
        this.popUpHeight = window.innerHeight;
        this.popUpWidth = window.innerWidth;
        this.referringPage = this.massEmail.ReferringPage;
        this.massEmailService.isBackClick = false;
        this.initialize();
    }

    initialize() {
        this.massEmail.Attachments = [];
        this.massEmailPreferences.Signature = '';
        this.massEmail.Body = '';
        if (this.massEmail.SendEmailToTeachers == null || this.massEmail.SendEmailToTeachers == undefined) {
            this.massEmail.SendEmailToTeachers = false;
        }
        this.selectedStudents = [];
        if (this.massEmail.Students != null && this.massEmail.Students != undefined) {
            this.selectedStudents = this.massEmail.Students;
            for (let i = 0; i < this.selectedStudents.length; i++) {
                this.selectedStudents[i].Name = this.getStudentName(this.selectedStudents[i]);
            }
        }
        this.selectedClasses = [];
        if (this.massEmail.MassEmailClasses != null && this.massEmail.MassEmailClasses != undefined) {
            this.selectedClasses = this.massEmail.MassEmailClasses;
        }

        this.selectedStudentTeam = [];
        if (this.massEmail.MassEmailStudentTeams != null && this.massEmail.MassEmailStudentTeams != undefined) {
            this.selectedStudentTeam = this.massEmail.MassEmailStudentTeams;
        }

        this.selectedStudentList = [];
        if (this.massEmail.MassEmailStudentLists != null && this.massEmail.MassEmailStudentLists != undefined) {
            this.selectedStudentList = this.massEmail.MassEmailStudentLists;
        }

        this.massEmail.From = this.userPreferences.generalPreferences.EmailFrom == 'Personal' ? this.currentUser.Email : this.loginSettings.DefaultEmailReplyToAddress;
        this.getMassEmailPreferences();
    }

    getPageInfo() {
        if (this.massEmail.ReferringPage == 'My Classes') {
            const subjectSectionIds: number[] = [];
            for (let i = 0; i < this.selectedClasses.length; i++) {
                if (this.loginSettings.V10) {
                    subjectSectionIds.push(this.selectedClasses[i].SSEC_ID);
                } else {
                    subjectSectionIds.push(this.selectedClasses[i].Id);
                }
            }
            // ONE-5178 Mass Email Error
            this.massEmailService.getStudentsByClass(subjectSectionIds, this.defaultYear.Id, this.defaultYear.SchoolID).subscribe(results => {
                this.massEmail.Students = results;
                this.selectedStudents = this.massEmail.Students;
                for (let x = 0; x < this.selectedStudents.length; x++) {
                    this.selectedStudents[x].IsSelected = true;
                    this.selectedStudents[x].SelectedClasses = [];
                    for (let y = 0; y < this.selectedStudents[x].SubjectSections.length; y++) {
                        this.selectedStudents[x].SelectedClasses[this.selectedStudents[x].SubjectSections[y]] = true;
                    }
                    this.selectedStudents[x].Name = this.getStudentName(this.selectedStudents[x]);
                }
                this.getParentTypes();
            });
        }
        else if (this.massEmail.ReferringPage == 'Student Teams') {
            const studentTeamsIds: number[] = [];
            for (let i = 0; i < this.selectedStudentTeam.length; i++) {
                studentTeamsIds.push(this.selectedStudentTeam[i].Id);
            }
            this.massEmailService.getStudentsByTeams(studentTeamsIds, this.defaultYear.Id, this.defaultYear.SchoolID).subscribe(results => {
                this.massEmail.Students = results;
                this.selectedStudents = this.massEmail.Students;
                for (let x = 0; x < this.selectedStudents.length; x++) {
                    this.selectedStudents[x].IsSelected = true;
                    this.selectedStudents[x].SelectedTeams = [];
                    for (let y = 0; y < this.selectedStudents[x].StudentTeams.length; y++) {
                        this.selectedStudents[x].SelectedTeams[this.selectedStudents[x].StudentTeams[y]] = true;
                    }
                    this.selectedStudents[x].Name = this.getStudentName(this.selectedStudents[x]);
                }
                this.getParentTypes();
            });
        }
        else if (this.massEmail.ReferringPage == 'Student Lists') {
            const studentListsIds: number[] = [];
            for (let i = 0; i < this.selectedStudentList.length; i++) {
                studentListsIds.push(this.selectedStudentList[i].ID);
            }
            this.massEmailService.getStudentsByLists(studentListsIds, this.defaultYear.Id, this.defaultYear.SchoolID).subscribe(results => {
                this.massEmail.Students = results;
                this.selectedStudents = this.massEmail.Students;
                for (let x = 0; x < this.selectedStudents.length; x++) {
                    this.selectedStudents[x].IsSelected = true;
                    this.selectedStudents[x].SelectedLists = [];
                    for (let y = 0; y < this.selectedStudents[x].StudentLists.length; y++) {
                        this.selectedStudents[x].SelectedLists[this.selectedStudents[x].StudentLists[y]] = true;
                    }
                    this.selectedStudents[x].Name = this.getStudentName(this.selectedStudents[x]);
                }
                this.getParentTypes();
            });
        }
        else {
            this.getParentTypes();
        }
    }

    getParentTypes() {
        if (this.loginSettings.V10 && (this.massEmail.ContactTypes == null || this.massEmail.ContactTypes.length == 0)) {
            this.massEmailService.getParentTypes(this.defaultYear.Id).subscribe(results => {
                const pTypes: ContactTypes[] = [];
                pTypes.push({ id: '(All)', label: '(All)' });
                pTypes.push({ id: '(All Guardians)', label: '(All Guardians)' });
                pTypes.push({ id: '(All Primary Contacts)', label: '(All Primary Contacts)' });
                pTypes.push({
                    id: '(All Primary Contacts who are Guardians)',
                    label: '(All Primary Contacts who are Guardians)'
                });
                for (let i = 0; i < results.length; i++) {
                    const type: ContactTypes = new ContactTypes();
                    type.id = results[i];
                    type.label = results[i];
                    pTypes.push(type);
                }
                this.massEmail.ContactTypes = pTypes;
                for (let i = 0; i < this.massEmail.ContactTypes.length; i++) {
                    if (this.massEmail.ContactTypes[i].label == '(All Primary Contacts)') {
                        this.massEmail.SelectedContactTypes.push(this.massEmail.ContactTypes[i].label);


                    }
                }
                this.showSelectRecipientsModal();
            });

        } else {
            this.showSelectRecipientsModal();
        }
    }

    showSelectRecipientsModal() {
        this.selectRecipiantDialogRef = this.dialog.open(SelectRecipientsComponent, {
            disableClose: true,
            data: _.cloneDeep(this.massEmail), // pass a copy not a reference
        });
        this.selectRecipiantDialogRef.afterClosed().subscribe((retValSelectRecipient: any) => {
            if (retValSelectRecipient != null) {
                if (retValSelectRecipient.Message == 'Continue') {
                    this.massEmail = retValSelectRecipient.massEmail;
                } else if (retValSelectRecipient.Message == 'Back') {
                    this.backClick();
                } else if (retValSelectRecipient == 'Close Clicked') {
                    // Do nothing
                } else {
                    this.cancelClick();
                }
            } else {
                this.cancelClick();
            }
        });
    }

    showViewRecipientsModal() {
        let recipients: EmailRecipient[] = [];
        // Get Contact Recipients
        this.massEmail.Recipients.forEach(recipient => {
            recipient.BCC.forEach(recip => {
                recipients.push(new EmailRecipient({
                    name: recip.LastName + ', ' + recip.FirstName,
                    email: recip.Email,
                    type: recip.Relationship == 'Teacher' ? 'Staff' : recip.Relationship == 'Student' ? 'Student' : (recip.Relationship == 'Team Staff' ? 'Team Staff' : 'Contact')
                }));
            });
            recipient.CC.forEach(recip => {
                recipients.push(new EmailRecipient({
                    name: recip.LastName + ', ' + recip.FirstName,
                    email: recip.Email,
                    type: recip.Relationship == 'Teacher' ? 'Staff' : recip.Relationship == 'Student' ? 'Student' : (recip.Relationship == 'Team Staff' ? 'Team Staff' : 'Contact')
                }));
            });
            recipient.To.forEach(recip => {
                recipients.push(new EmailRecipient({
                    name: recip.LastName + ', ' + recip.FirstName,
                    email: recip.Email,
                    type: recip.Relationship == 'Teacher' ? 'Staff' : recip.Relationship == 'Student' ? 'Student' : (recip.Relationship == 'Team Staff' ? 'Team Staff' : 'Contact')
                }));
            });
        });

        // Get additional recipients
        let additionalEmails = [];
        if (this.massEmail.AdditionalRecipients.to) {
            additionalEmails = additionalEmails.concat(this.massEmail.AdditionalRecipients.to.split(';'));
        }
        if (this.massEmail.AdditionalRecipients.cc) {
            additionalEmails = additionalEmails.concat(this.massEmail.AdditionalRecipients.cc.split(';'));
        }
        if (this.massEmail.AdditionalRecipients.bcc) {
            additionalEmails = additionalEmails.concat(this.massEmail.AdditionalRecipients.bcc.split(';'));
        }
        for (let i = 0; i < additionalEmails.length; i++) {
            additionalEmails[i] = additionalEmails[i].trim();
            recipients.push(new EmailRecipient({ email: additionalEmails[i], type: 'Additional' }));
        }
        if (this.massEmail.OneEmailPerHousehold) {
            recipients = recipients.filter((filterRecipient, index) =>
                recipients.findIndex(tempRecipient => filterRecipient.email == tempRecipient.email) == index
            );
        }
        this.dialog.open(ViewRecipientsModalComponent, {
            width: '60vw',
            height: '55vh',
            autoFocus: false,
            disableClose: true,
            data: { recipients: recipients, includeTeachers: this.massEmail.SendEmailToTeachers, includeTeamStaffMembers: this.massEmail.SendEmailToTeamStaffMembers }
        });
    }

    getMassEmailPreferences() {
        this.userPreferencesService.getUserPreferences(0, '/OneSISMassEmail').subscribe(results => {
            this.userPreferences.massEmailPreferences = JSON.parse(results[0]);
            this.massEmailPreferences = JSON.parse(JSON.stringify(this.userPreferences.massEmailPreferences));
            this.massEmail.CreateCommunicationLog = this.massEmailPreferences.CreateCommunicationLog;
            if (this.massEmailPreferences.Signature != '' && this.massEmail.Body == '') {
                this.massEmail.Body = this.massEmail.Body + '<p><br/><br/><br/></p>' + this.massEmailPreferences.Signature;
            }
            this.getPageInfo();
        });
    }

    getStudentName(student) {
        const nickName = student.NickName;
        const firstName = student.FirstName;
        const middleName = student.MiddleName;
        const lastName = student.LastName;
        let studentName = '';
        if (this.userPreferences.generalPreferences.StudentNameFormat == 'LNF') {
            studentName = lastName + ', ';
        }
        if (this.userPreferences.generalPreferences.StudentNameFormat != 'FILN') {
            studentName = studentName + firstName;
        }
        if (this.userPreferences.generalPreferences.StudentNameFormat == 'FILN') {
            studentName = studentName + firstName.substr(0, 1);
        }
        if (this.userPreferences.generalPreferences.ShowNickname == true && nickName != null && nickName != '') {
            studentName = studentName + ' ' + '"' + nickName + '"';
        }
        if (this.userPreferences.generalPreferences.StudentMiddleNameFormat == 'SEN' && middleName != null && middleName != '') {
            studentName = studentName + ' ' + middleName;
        }
        if (this.userPreferences.generalPreferences.StudentMiddleNameFormat == 'SFL' && middleName != null && middleName != '') {
            studentName = studentName + ' ' + middleName.substr(0, 1);
        }
        if (this.userPreferences.generalPreferences.StudentNameFormat != 'LNF' && this.userPreferences.generalPreferences.StudentNameFormat != 'FNLI') {
            studentName = studentName + ' ' + lastName;
        }
        if (this.userPreferences.generalPreferences.StudentNameFormat == 'FNLI') {
            studentName = studentName + ' ' + lastName.substr(0, 1);
        }
        return studentName;
    }

    closeClick() {
        this.dialogRef.close('Cancel was clicked.');
    }

    backClick() {
        this.massEmailService.isBackClick = true;
        this.dialogRef.close('Back was clicked.');
    }

    cancelClick() {
        this.dialogBox.close();
    }

    sendEmailsClick(sendTest = false) {
        let iserror: boolean;
        iserror = false;
        this.errors = [];
        // this.validateEmail();

        let attachmentSize = 0;
        for (let j = 0; j < this.massEmail.Attachments.length; j++) {
            if (this.massEmail.Attachments[j].Base64String != undefined && this.massEmail.Attachments[j].Base64String != null && this.massEmail.Attachments[j].Base64String != '') {
                attachmentSize = attachmentSize + (window.atob(this.massEmail.Attachments[j].Base64String).length / (1024 * 1024));
            }
        }
        if (attachmentSize > 10) {
            this.errors.push({
                fieldRef: null,
                fieldName: '',
                errorMsg: 'The total size of the files you have attached exceeds the 10 MB limit.'
            });
        }

        if ((this.massEmail.Subject == null || this.massEmail.Subject.trim().length == 0)
            && (this.massEmail.Body == null || this.massEmail.Body.trim().length == 0)
            && (this.massEmail.Attachments == null || this.massEmail.Attachments.length == 0)) {
            this.errors.push({
                fieldName: '',
                fieldRef: this.attachmentFieldRef,
                errorMsg: 'Email has no content, subject or attachment'
            });
            this.errors.push({
                fieldName: '',
                fieldRef: null,
                errorMsg: '',
            });
            this.errors.push({
                fieldName: '',
                fieldRef: null,
                errorMsg: '',
            });
            // iserror = true;
        } else if ((this.massEmail.Subject == null || this.massEmail.Subject.trim().length == 0
            || this.massEmail.Body == null || this.massEmail.Body.trim().length == 0) && this.errors.length == 0) {
            this.sendEmailsWarningDialogRef = this.dialog.open(SendEmailsWarningComponent, {
                width: '300px',
                // height: '100px',
                disableClose: true,
                data: { massEmailObj: this.massEmail }
            });
            this.sendEmailsWarningDialogRef.afterClosed().subscribe(result => {
                if (result == 'Send Anyway Was Clicked') {
                    this.sendEmails(sendTest);
                } else {
                    // DO Nothing
                }
            }
            );
        }
        else if (!this.massEmail.From || this.massEmail.From == '') {
            this.generalConfirmationDialog = this.dialog.open(GeneralConfirmationComponent, { panelClass: 'tyl-mat-dialog', disableClose: true });
            this.generalConfirmationDialog.componentInstance.disableConfirmation = true;
            this.generalConfirmationDialog.componentInstance.headerLabel = 'Error';
            this.generalConfirmationDialog.componentInstance.confirmMessage = 'You do not have a valid email address to send Mass Emails';
        }
        else {
            if (this.errors.length == 0) {
                this.sendEmails(sendTest);
            }
        }
    }

    sendEmails(sendTest = false) {
        let email: any = {};
        if (sendTest == false) {
            email = {
                From: this.massEmail.From,
                Recipients: this.massEmail.Recipients,
                Subject: this.massEmail.Subject,
                Message: this.massEmail.Body,
                Attachments: this.massEmail.Attachments,
                StudentSelection: this.massEmail.StudentRecipientType,
                HouseholdParentsSelection: this.massEmail.HouseholdRecipientType,
                NonResidentParentsSelection: this.massEmail.NonHouseholdRecipientType,
                IncludeAllEvenNotRequestMailing: this.massEmail.IncludeAll,
                SendEmailToTeacher: this.massEmail.SendEmailToTeachers,
                CreateCommunicationLog: this.massEmail.CreateCommunicationLog,
                SelectedContactTypes: this.massEmail.SelectedContactTypes,
                OneEmailPerHousehold: this.massEmail.OneEmailPerHousehold
            };

            // Check for additional recipients
            this.addAdditionalEmails();
        } else {
            const sendTestRecipient: Recipient[] = [];
            const rec: Recipient = {
                StudentID: 0,
                To: [
                    {
                        ID: 0,
                        Email: this.userEmailAddress,
                        IsGuardian: false,
                        IsPrimaryParent: false,
                        Relationship: 'Undefined',
                        RequestsMailings: false,
                        FirstName: '',
                        LastName: ''
                    }
                ],
                CC: [],
                BCC: []
            };
            sendTestRecipient.push(rec);

            email = {
                From: this.massEmail.From,
                Recipients: sendTestRecipient,
                Subject: this.massEmail.Subject + ' - TEST MESSAGE',
                Message: this.massEmail.Body,
                Attachments: this.massEmail.Attachments,
                StudentSelection: this.massEmail.StudentRecipientType,
                HouseholdParentsSelection: this.massEmail.HouseholdRecipientType,
                NonResidentParentsSelection: this.massEmail.NonHouseholdRecipientType,
                IncludeAllEvenNotRequestMailing: this.massEmail.IncludeAll,
                SendEmailToTeacher: this.massEmail.SendEmailToTeachers,
                CreateCommunicationLog: this.massEmail.CreateCommunicationLog,
                SelectedContactTypes: this.massEmail.SelectedContactTypes,
                OneEmailPerHousehold: this.massEmail.OneEmailPerHousehold
            };
        }

        const area = 'Mass Email';
        if (this.loginSettings.V10) {
            this.massEmailService.sendMassEmail(email, true, area, this.currentUser.LoginSchoolId, this.defaultYear.Id).subscribe(results => {
                email.Recipients = [];
                const confirmationEmailRecipient = {
                    ID: this.currentUser.MemberId,
                    Email: this.currentUser.Email,
                    Relationship: 'Sender'
                };
                const r = {
                    To: [],
                    CC: [],
                    BCC: []
                };
                r.To.push(confirmationEmailRecipient);
                email.Recipients.push(r);
                email.CreateCommunicationLog = false;

                this.massEmailService.sendMassEmail(email, true, area, this.currentUser.LoginSchoolId, this.defaultYear.Id).subscribe(resultsObj => {
                    this.jobSentToQueueDialogRef = this.dialog.open(JobSentToQueueComponent, {
                        width: '350px',
                        height: '160px',
                        disableClose: true,
                        data: {
                            dialogTitle: 'Job Sent to Queue',
                            dialogContent: 'The mass email has been sent to the queue'
                        }
                    });
                    this.jobSentToQueueDialogRef.afterClosed().subscribe(result => {
                        if (result == 'Close was clicked') {
                            this.dialogRef.close('Mass Email Sent.');
                        }
                    });
                });
            });
        } else {
            this.massEmailService.sendMassEmail(email, true, area, this.defaultYear.SchoolID, this.defaultYear.Id).subscribe(results => {
                if (sendTest == false) {
                    this.jobSentToQueueDialogRef = this.dialog.open(JobSentToQueueComponent, {
                        width: '350px',
                        height: '160px',
                        disableClose: true
                    });
                    this.jobSentToQueueDialogRef.afterClosed().subscribe(result => {
                        if (result == 'Close was clicked') {
                            this.dialogRef.close('Mass Email Sent.');
                        }
                    });
                }
            });
        }
    }

    preferencesClick() {
        this.userPrefDialogRef = this.dialog.open(UserPreferencesWindowComponent, {
            width: '1000px',
            height: '800px',
        });
        this.userPrefDialogRef.componentInstance.staffAssignedPortals = this.staffAssignedPortals;
        this.userPrefDialogRef.afterClosed().subscribe(result => {
        });
    }

    exportAddressesClick() {

    }

    addAttachmentClick() {
        this.massEmailAttachmentDialogRef = this.dialog.open(MassEmailAttachmentComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            width: '400px'
        });
        this.massEmailAttachmentDialogRef.afterClosed().subscribe((retValAttachment: Attachment) => {
            if (retValAttachment != undefined && retValAttachment != null && retValAttachment.AttachmentFileName != '') {
                this.massEmail.Attachments.push(retValAttachment);
            }
        });
    }

    deleteAttachment(attchement: Attachment) {
        const index = this.massEmail.Attachments.indexOf(attchement);
        this.massEmail.Attachments.splice(index, 1);
    }

    // Send Test Email
    sendTestEmail() {
        this.sendTestEmailDislogRef = this.dialog.open(SendTestEmailComponent, {
            width: '400px',
            height: '200px',
            disableClose: true
        });
        this.sendTestEmailDislogRef.afterClosed().subscribe(result => {
            if (result.Message == 'SendTest') {
                this.userEmailAddress = result.EmailAddress;
                this.sendEmailsClick(true);
            }
        });
    }

    private addAdditionalEmails() {
        if (Object.keys(this.massEmail.AdditionalRecipients).length > 0) {
            // separate emails out
            const { to, cc, bcc } = this.massEmail.AdditionalRecipients;
            if (to) {
                let toRecipients = to.split(';');
                // Trim white space
                for (let i = 0; i < toRecipients.length; i++) {
                    toRecipients[i] = toRecipients[i].trim();
                }
                // remove empty emails
                for (let i = 0; i < toRecipients.length; i++) {
                    toRecipients = toRecipients.filter(em => em != '');
                    const rec: Recipient = {
                        StudentID: 0,
                        To: [
                            {
                                ID: 0,
                                Email: toRecipients[i],
                                IsGuardian: false,
                                IsPrimaryParent: false,
                                Relationship: 'Undefined',
                                RequestsMailings: false,
                                FirstName: '',
                                LastName: ''
                            }
                        ],
                        CC: [],
                        BCC: []
                    };
                    this.massEmail.Recipients.push(rec);
                }
            }
            if (cc) {
                let ccRecipients = cc.split(';');
                // Trim white space
                for (let i = 0; i < ccRecipients.length; i++) {
                    ccRecipients[i] = ccRecipients[i].trim();
                }
                // remove empty emails
                for (let i = 0; i < ccRecipients.length; i++) {
                    ccRecipients = ccRecipients.filter(em => em != '');
                    const rec: Recipient = {
                        StudentID: 0,
                        CC: [
                            {
                                ID: 0,
                                Email: ccRecipients[i],
                                IsGuardian: false,
                                IsPrimaryParent: false,
                                Relationship: 'Undefined',
                                RequestsMailings: false,
                                FirstName: '',
                                LastName: ''
                            }
                        ],
                        To: [],
                        BCC: []
                    };
                    this.massEmail.Recipients.push(rec);
                }
            }
            if (bcc) {
                let bccRecipients = bcc.split(';');
                // Trim white space
                for (let i = 0; i < bccRecipients.length; i++) {
                    bccRecipients[i] = bccRecipients[i].trim();
                }
                // remove empty emails
                for (let i = 0; i < bccRecipients.length; i++) {
                    bccRecipients = bccRecipients.filter(em => em != '');
                    const rec: Recipient = {
                        StudentID: 0,
                        BCC: [
                            {
                                ID: 0,
                                Email: bccRecipients[i],
                                IsGuardian: false,
                                IsPrimaryParent: false,
                                Relationship: 'Undefined',
                                RequestsMailings: false,
                                FirstName: '',
                                LastName: ''
                            }
                        ],
                        To: [],
                        CC: []
                    };
                    this.massEmail.Recipients.push(rec);
                }
            }
        }
    }
}
